import { Category } from './category.model';

/**
 * CMS Video model
 */
export class Video {
  constructor(
    public id: string,
    public title: string,
    public embed_url: string,
    public external_url: string,
    public external_link_cta: string,
    public duration: string,
    public date_added: Date,
    public categories: Category[],
    public description: string,
    public slug: string
  ) {}
}
